import { RootStoreState } from '@src/models/app.types'
import { HealthDataMeasurementType } from '@src/types'

export const effectiveDailyMeasurementSelector = (
  state: RootStoreState,
  date: string,
  type: HealthDataMeasurementType,
) => state.dailyMeasurements.effectiveMeasurements[date]?.[type]
